<template>
    <th @mouseenter="moseEnter()" :class="aligment" @mouseleave="moseLeave()" @click="emitOrder()">{{nombre}} 
      <template v-if="disable == false && selected == true || disable == false && hover == true">
        <i class="pull-right" :class="{ 'icon-arrow-down' : filter, 'icon-arrow-up' : filter == false }"></i>
      </template>
    </th>
</template>
<script>
import EventBus from '@/event-bus.js'
export default {
  name: 'tablehead',
  props: ['name', 'group', 'order', 'default', 'position'],
  data () {
    return {
      filter: true,
      disable: false,
      hover: false,
      selected: false
    }
  },
  methods: {
    moseEnter () {
      this.hover = true
    },
    moseLeave () {
      this.hover = false
    },
    emitOrder () {
      if (this.disable === false) {
        let information = {
          'name': this.order,
          'filter': this.filter
        }
        EventBus.$emit('filter' + this.group, information)
        this.filter = (this.filter === false)
        this.selected = true
      }
    }
  },
  computed: {
    aligment () {
      if (this.position === 'center') {
        return 'center'
      }
      return ''
    },
    nombre () {
      return this.name
    }
  },
  created () {
    let vue = this
    if (this.default) {
      this.filter = false
      this.emitOrder()
    }
    EventBus.$on('filter' + this.group, function (information) {
      if (vue.order !== information.name) {
        vue.filter = true
        vue.selected = false
      }
    })
    EventBus.$on('disableOrder' + this.group, function (data) {
      vue.disable = data
    })
  }
}
</script>
<style>
i {
    margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/components/TableHead.vue